import React, { useEffect, useState } from "react";
import { LineWave } from "react-loader-spinner";

import { useStudent } from "src/contexts/student";
import api from "src/rest/api";
import TabLayout from "./TabLayout";

export const noteClassname =
  "flex flex-col w-full p-5 md:border md:border-t-0 md:border-b md:first-of-type:rounded-t md:last-of-type:rounded-b md:last-of-type:border-b-0 md:first-of-type:rounded-tl md:first-of-type:rounded-tr md:last-of-type:rounded-bl md:last-of-type:rounded-br md:w-auto md:min-w-[calc(100vw-107px)]";

const StudentNotes: React.FC = () => {
  const { student } = useStudent();

  const [notes, setNotes] = useState<string[]>();

  useEffect(() => {
    if (!notes)
      api
        .post("/students/getnotes", { ref: student?.id })
        .then((res) => setNotes(res.data));
  }, []);

  function RemoveNote(index: number) {
    if (!notes) return;

    const newNotes = [...notes];

    try {
      newNotes.splice(index, 1);
      setNotes(newNotes);
    } finally {
      UploadNote(newNotes);
    }
  }

  function AddNote() {
    if (!notes) return;

    const newNotes = [...notes, ""];
    setNotes(newNotes);
    UploadNote(newNotes);
  }

  function UploadNote(data: string[]) {
    console.log("uploading notes:", data);
    if (!student) return;
    api
      .post("/students/savenotes", {
        ref: student.id,
        data: data,
      })
      .catch((err) => {
        alert(err);
        //TODO: Adicionar Alerta (hook)
      });
  }

  if (!notes) {
    return (
      <div className="flex flex-1 items-center justify-center">
        <LineWave width={100} height={100} color="#dd1a30" />
      </div>
    );
  } else {
    return (
      <ul className="flex flex-1 flex-col overflow-auto">
        {notes && (
          <TabLayout RemoveNote={RemoveNote} arr={notes} AddNote={AddNote} />
        )}
      </ul>
    );
  }
};

export default StudentNotes;
